import React, { FC } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { Users } from './Users';
import { AddUser } from './AddUser';
import { EditUser } from './EditUser';

export const UsersRouter: FC = () => {
  const { path } = useRouteMatch();

  return (<Switch>
    <Route exact path={path}>
      <Users/>
    </Route>
    <Route path={`${path}/add`}>
      <AddUser/>
    </Route>
    <Route path={`${path}/:id`}>
      <EditUser/>
    </Route>
  </Switch>);
};
